<template>
  <!--交易游戏记录-->
  <div class="trade-game-record-container">
    <custom-filter class="custom-filter" :filterConfig="filterConfig" :defaultFilter="filterParams" @filterSearch="search" @filterRest="rest">
      <template slot="inviteType" scope="scope">
        <el-select v-model="scope.filter.inviteType" :popper-append-to-body="false" placeholder="">
          <el-option v-for="(item) in lowerLevel" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </template>
 

       <template slot="symbol" scope="scope">
        <el-select v-model="scope.filter.symbol" :popper-append-to-body="false" placeholder="" clearable>
          <el-option v-for="(item) in coinList" :label="item.symbol" :value="item.symbol" :key="item.symbol"></el-option>
        </el-select>
      </template>
     
      <template slot="status" scope="scope">
        <el-select v-model="scope.filter.status" :popper-append-to-body="false" placeholder="" clearable>
          <el-option v-for="(item) in optionRecordOrderStatus" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </template>
      <template slot="type" scope="scope">
        <el-select v-model="scope.filter.type" :popper-append-to-body="false" placeholder="" clearable>
          <el-option v-for="(item) in optionRecordTimeMap" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </template>
    </custom-filter>
    <custom-table class="custom-table" :dataSource="dataSource" @changeSize="changeSize" @changeNum="changeNum">
    
      <template slot="rewardDirect" scope="scope">
        <span>
          {{scope.row.status == -2 ? $t('pageTitle.yichexiao') : statusMap[scope.row.rewardDirect] || '--'}}
        </span>
      </template>
      <template slot="rewardAmount" scope="scope">
        <span v-if="scope.row.status === 0">
          --
        </span>
        <span v-else-if="scope.row.status == '-2'">0.000</span>
        <span v-else :class="scope.row.rewardAmount > 0 ? 'green' : 'red'">
          {{
              (scope.row.rewardAmount ? "+" : "") +
                  $Decimal(scope.row.rewardAmount || 0)
                    .sub($Decimal(scope.row.amount))
                    .toFixed(numberScale) || '--'
          }}
        </span>
      </template>
      <template slot="status" scope="scope">
        <span :class="scope.row.status == 0 ? 'red' : ''">{{optionOrderStatus[scope.row.status]}}</span>
      </template>
      <template slot="type" scope="scope">
        <span>{{ timeMap[scope.row.type] }}&nbsp;({{
              moment(scope.row.startTime).format("HH:mm")
            }}~{{ moment(scope.row.endTime).format("HH:mm") }})</span>
      </template>
    </custom-table>
  </div>
</template>

<script>
  import CustomFilter from '@/components/CustomFilter.vue'
  import CustomTable from '@/components/CustomTable.vue'
  import {getLowerTradeGameRecord} from '@/request/api.js'
  import moment from 'moment'
  import {state} from '@/store.js'
  const date = new Date();
  export default {
    name: "TradeGameRecord",
    components: {
      CustomFilter,
      CustomTable
    },
    data() {
      return {
        moment: moment,
        dialogVisible: false,

        filterParams: {
          inviteType: 4,
          time: [new Date(date.toLocaleDateString()).getTime(), new Date(date.toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1]
        },
        filterConfig: [

        ],
        dataSource: {
          data: [], // 表格数据
          cols: [], // 表格的列数据
          handleSelectionChange: () => {}, //点击行选中多选返回选中数组
          isSelection: false, // 表格有多选时设置
          isOperation: false, // 表格有操作列时设置
          isIndex: false, // 列表序号
          loading: true, // loading
          isPage: true,
          pageData: {
            total: 0, // 总条数
            pageSize: 10, // 每页数量
            pageNum: 1, // 页码
            pageSizes: [ 10, 20, 50] // 每页数量
          },
          operation: {
            label: '操作',
            width: '100',
            data: [
              {
                label:'详情',
                handleRow: this.handleRow,
                type: 'text'
              }
            ]
          }
        },


        // 级别
        lowerLevel: [],
        // 团队等级
        teamLevel: [],
        // vip等级
        vipLevel: [],
        // 今日，昨日....
        dataTimeVal: [],
        statusArr: [],
        optionRecordTimeMap: [],
        optionRecordOrderStatus: [],
        optionRecordCalResultMap: [],

      }
    },
    computed: {
      chargeStatus: () => state.chargeStatus,
      numberScale: () => state.numberScale,
      timeMap: () => state.optionRecordTimeMap,
      optionOrderStatus: () => state.optionRecordOrderStatus,
      statusMap: () => state.optionRecordCalResultMap,
      coinList: () => state.coinList
    },
    watch: {
      '$i18n.locale': {
        handler() {
          this.lowerLevel = [
            {
              label: this.$t('version22.lv1'),
              value: 1
            },
            {
              label: this.$t('version22.lv2'),
              value: 2
            }
            ,
            {
              label: this.$t('version22.lv3'),
              value: 3
            }
            ,
            {
              label: this.$t('version22.lvAll'),
              value: 4
            }
          ].concat(state.userSetting.inspectLevel !== 0 ? [{
            label: this.$t('pageTitle.quanbu'),
            value: 5
          }] : [])
          this.teamLevel = [
            {
              label: 'LV1',
              value: 1
            },
            {
              label: 'LV2',
              value: 2
            },
            {
              label: 'LV3',
              value: 3
            },
            {
              label: 'LV4',
              value: 4
            },
            {
              label: 'LV5',
              value: 5
            },
            {
              label: 'LV6',
              value: 6
            }
          ]
          this.vipLevel = [
            {
              label: 'VIP1',
              value: 1
            },
            {
              label: 'VIP2',
              value: 2
            },
            {
              label: 'VIP3',
              value: 3
            },
            {
              label: 'VIP4',
              value: 4
            },
            {
              label: 'VIP5',
              value: 5
            },
            {
              label: 'VIP6',
              value: 6
            },
            {
              label: 'VIP7',
              value: 7
            },
            {
              label: 'VIP8',
              value: 8
            },
            {
              label: 'VIP9',
              value: 9
            }
          ]
          this.dataTimeVal = [
            {label: this.$t("Transfer.jintian"), value: 0},
            {label: this.$t("Transfer.zuotian"), value: 1},
            {label: this.$t("Transfer.benzhou"), value: 2},
            {label: this.$t("Transfer.shangzhou"), value: 3},
            {label: this.$t("Transfer.benyue"), value: 4},
            {label: this.$t("Transfer.shangyue"), value: 5},
          ]
          this.statusArr = [
            {label: this.$t("saas.unRecharge"), value: 0},
            {label: this.$t("version21.hasRecharge"), value: 1},
          ]
          this.optionRecordTimeMap = [
            {label: '30s' , value: 'THIRTY_SECOND'},

            {label: '1' + this.$t('chart.minute'), value: 'ONE_MIN'},
            {label: '3' + this.$t('chart.minute'), value: 'THREE_MIN'},
            {label: '5' + this.$t('chart.minute'), value: 'FIVE_MIN'},
          ]
 
          this.optionRecordOrderStatus = [
            {label: this.$t('version3.unOpen'), value: 0},
            {label: this.$t('version3.hasBingGo'), value: 1},
            {label: this.$t('version3.unBingGo'), value: '-1'},
      
            {label: this.$t('pageTitle.yichexiao'), value: '-2'}
          ]

          this.betTypeMap = {
            RED : 'version19.RG_2_0',
            GREEN : 'version19.RG_2_1',
            PURPLE : 'version19.RG_5_1',
            BIG: 'version19.BLK_2_0',
            SMALL: 'version19.BLK_2_1',
            ODD: 'version19.BLK_2_2',
            EVEN: 'version19.BLK_2_3'
          }
  

          this.filterConfig = [
            {
              label: this.$t('version22.username'),
              prop: 'memberAccount',
              type: 'input',
              isTemplate: false
            },
            {
              label: this.$t('yaoqin.my_column4'),
              prop: 'inviteType',
              isTemplate: true,
            },
            {
              label: this.$t('pageTitle.jiaoyidui'),
              prop: 'symbol',
              isTemplate: true
            },

          
       
            {
              label: this.$t('version15.status'),
              prop: 'status',
              isTemplate: true
            },
            {
              label: this.$t('pageTitle.type'),
              prop: 'type',
              isTemplate: true
            },
            {
              label: this.$t('pageTitle.time'),
              prop: 'time',
              type: 'datetime',
              isTemplate: false
            },
          ]
          this.$set(this.dataSource, 'cols', [
            {
              label: this.$t('version22.username'),
              prop: 'memberAccount',
            },
            {
              label: this.$t('yaoqin.my_column4'),
              prop: 'level',
              isCodeTableFormatter: (val) => {
                return val.level + this.$t('version22.singleLevelTxt')
              }
            },
            {
              label: this.$t('pageTitle.jiaoyidui'),
              prop: 'symbol',
            },
            {
              label: 'No.',
              prop: 'orderNo',
              width: 150,
            },
              {
              label: this.$t('version18.issue'),
              prop: 'issueNo',
            },
              {
              label: this.$t('pageTitle.type'),
              prop: 'type',
              isCodeTableFormatter: (val) => {
                return this.optionRecordTimeMap.find(item=>item.value === val.type)?.label || '--'
              }
            },
            {
              label: this.$t('version20.betNumber'),
              prop: 'betType',
              isCodeTableFormatter: (val) => {
                return val.betType=="SINGLE" ? val.betValue : this.$t(`${this.betTypeMap[val.betType]}`) || "--"
              }
            },
            {
              label: this.$t('version3.betTime'),
              prop: 'createTime',
              width: 150,
              isCodeTableFormatter: function(val) {
                return moment(val.createTime).format('YYYY-MM-DD HH:mm:ss')
              }
            },
            {
              label: this.$t('version10.betMoney'),
              prop: 'amount',
              width: 150,
              isCodeTableFormatter: (val) => {
                return this.toFloor(val.amount, this.numberScale) + 'USDT'
              }
            },
          
          
            {
              label: this.$t('version23.profitAndLossAmount'),
              prop: 'rewardAmount',
              width: 150,
              isTemplate: true,
            },
            {
              label: this.$t('version15.status'),
              prop: 'status',
              width: 150,
              isTemplate: true
            },
        
          ])
        },
        immediate: true
      }
    },
    created() {

    },
    mounted() {
      this.getList()
    },
    methods: {
      showTip() {
        this.dialogVisible = true
      },
      search(filter) {
        this.filterParams = filter;
        this.dataSource.pageData.pageNum = 1
        this.getList();
      },
      rest(filter) {
        this.filterParams = filter;
        this.dataSource.pageData.pageNum = 1
        this.getList()
      },
      changeSize(val) {
        this.dataSource.pageData.pageSize = val
        this.getList();
      },
      changeNum(val) {
        this.dataSource.pageData.pageNum = val
        this.getList();
      },
      handleRow() {
      },
      getList() {
        const filter = this.deepClone(this.filterParams);
        if (filter.time && filter.time.length > 0) {
          filter.startTime = filter.time[0];
          filter.endTime = filter.time[1];
          delete filter.time
        }

        this.$set(this.dataSource, 'loading', true);
        const params = {
          current: this.dataSource.pageData.pageNum,
          size: this.dataSource.pageData.pageSize
        };

        for(let key in filter) {
          if (filter[key] === '') {
            delete filter[key]
          }
        }

        getLowerTradeGameRecord(Object.assign({}, filter, params)).then(res => {
          if (res.code === 200) {
            this.dataSource.pageData.total = res.data.total
            this.dataSource.data = res.data.records
          } else {
            this.$message.error(res.msg)
          }
          this.$set(this.dataSource, 'loading', false);
        }).catch(e => {
          if (e?.code === 40301) this.$message.error(this.$t('list.butigongfuwu'))
          if (e?.code === 444) this.$message.error(this.$t('version3.maintain'))
          this.$set(this.dataSource, 'loading', false);
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .green {
    color: #3fb388;
  }
  .red {
    color: #f2475c;
  }
</style>
